import dynamic from 'next/dynamic';

export default dynamic(() => import('./DateTimeRangePickerInternal'), { ssr: false });
